import React from 'react';

function FacesPage({ presenters }) {
  const pages = [];
  for (let i = 0; i < presenters.length; i += 12) {
    pages.push(presenters.slice(i, i + 12));
  }

  if (pages.length === 0) {
    pages.push([]);
  }

  return (
    <div>
      {pages.map((pagePresenters, pageIndex) => (
        <div
          key={pageIndex}
          className="faces-print-page"
          style={{
            width: '8.5in',
            minHeight: '11in',
            padding: '0.4in',
            backgroundColor: 'white',
            marginBottom: '32px',
            boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
            boxSizing: 'border-box',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          {/* Page Header */}
          <div style={{
            textAlign: 'center',
            marginBottom: '24px',
            paddingBottom: '12px',
            borderBottom: '3px solid #1a1a2e'
          }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '800',
              color: '#1a1a2e',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              margin: 0
            }}>
              Presenter Faces
            </h2>
            {pageIndex > 0 && (
              <p style={{ color: '#718096', fontSize: '12px', margin: '4px 0 0' }}>
                Page {pageIndex + 1}
              </p>
            )}
          </div>

          {/* 3x4 Grid */}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gridTemplateRows: 'repeat(4, 1fr)',
            gap: '16px',
            height: 'calc(11in - 1.4in)',
            maxWidth: '900px',
            margin: '0 auto',
          }}>
            {Array.from({ length: 12 }).map((_, slotIndex) => {
              const presenter = pagePresenters[slotIndex];
              return (
                <div
                  key={slotIndex}
                  style={{
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: presenter ? 'white' : '#f7fafc',
                  }}
                >
                  {presenter ? (
                    <>
                      <div style={{
                        flex: 1,
                        backgroundColor: '#e2e8f0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden',
                        minHeight: 0,
                      }}>
                        {presenter.photo ? (
                          <img
                            src={presenter.photo}
                            alt={presenter.name}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'contain',
                              backgroundColor: '#e2e8f0'
                            }}
                          />
                        ) : (
                          <div style={{
                            fontSize: '64px',
                            color: '#a0aec0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            height: '100%'
                          }}>
                            👤
                          </div>
                        )}
                      </div>
                      <div className="presenter-info-bar" style={{
                        padding: '10px',
                        textAlign: 'center',
                        backgroundColor: '#1a1a2e',
                        flexShrink: 0,
                        WebkitPrintColorAdjust: 'exact',
                        printColorAdjust: 'exact'
                      }}>
                        <p className="presenter-name" style={{
                          fontWeight: '700',
                          fontSize: '14px',
                          color: 'white',
                          margin: '0 0 2px',
                          lineHeight: '1.2'
                        }}>
                          {presenter.name}
                        </p>
                        <p className="presenter-title" style={{
                          fontSize: '12px',
                          color: '#90cdf4',
                          margin: 0,
                          lineHeight: '1.2'
                        }}>
                          {presenter.jobTitle}
                        </p>
                      </div>
                    </>
                  ) : (
                    <div style={{
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#e2e8f0',
                      fontSize: '24px'
                    }}>
                      —
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function Faces(props) {
  const presenters = props.presenters || [];
  const currentShowId = props.currentShowId;

  const handleExportPDF = async () => {
    try {
      const token = localStorage.getItem('cvs_token');
      const API_URL = window.location.hostname === 'localhost' ? 'http://localhost:4000' : 'https://showflow.creativevideoservices.net';
      const response = await fetch(`${API_URL}/api/shows/${currentShowId}/faces-pdf`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ presenters })
      });
      if (!response.ok) throw new Error('PDF generation failed');
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const disposition = response.headers.get('Content-Disposition');
      const match = disposition && disposition.match(/filename="(.+)"/);
      a.download = match ? match[1] : 'faces.pdf';
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      alert('PDF generation failed. Please try again.');
    }
  };

  return (
    <div>
      <div className="no-print">
        <div className="page-header">
          <h1>Faces</h1>
          <p>Print-ready presenter sheet. 12 presenters per page, formatted for 8.5 x 11.</p>
        </div>
        <div style={{ marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button
            onClick={handleExportPDF}
            style={{
              backgroundColor: '#48bb78',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              padding: '10px 24px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            Export Faces PDF
          </button>
          <p style={{ color: '#718096', fontSize: '13px' }}>
            {presenters.length} presenter{presenters.length !== 1 ? 's' : ''} —&nbsp;
            {Math.ceil(Math.max(presenters.length, 1) / 12)} page{Math.ceil(Math.max(presenters.length, 1) / 12) !== 1 ? 's' : ''}
          </p>
        </div>
      </div>

      <FacesPage presenters={presenters} />

      <style>{`
        @media print {
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .no-print { display: none !important; }
          .faces-print-page {
            box-shadow: none !important;
            margin: 0 !important;
            padding: 0.4in !important;
            min-height: 0 !important;
            height: 11in !important;
            page-break-after: always;
          }
          .faces-print-page:last-child {
            page-break-after: auto !important;
          }
          body { background: white !important; }
          .header { display: none !important; }
          .page-content { padding: 0 !important; }
          .presenter-name {
            color: black !important;
            font-size: 15px !important;
          }
          .presenter-title {
            color: black !important;
            font-size: 13px !important;
          }
          .presenter-info-bar {
            background-color: white !important;
          }
        }
      `}</style>
    </div>
  );
}

export default Faces;